const _ = require('lodash');

module.exports = {
    /**
     * @param {Object} args
     * @param {Object|undefined} args.auth
     * @param {String|undefined} args.auth.access_token
     * @param {String|undefined} args.auth.expires_in
     * @param {Baobab} state
     * @param {Function} output
     * @param {Object} services
     * @param {Object} services.context
     */
    setSessionToken ({ auth }, state, output, { context }) {
        const accessToken = _.get(auth, 'access_token');
        const refreshToken = _.get(auth, 'refresh_token');
        const expires = new Date(Date.now() + (3600 * 24 * 1000));

        // Кука для токена на сутки
        context.cookie.set({
            key: 'access_token',
            value: accessToken,
            path: '/',
            expires
        });

        // Кука для рефреш-токена на 30 дней
        context.cookie.set({
            key: 'refresh_token',
            value: refreshToken,
            path: '/',
            expires: new Date(Date.now() + (3600 * 24 * 1000 * 30))
        });
    },

    unsetSessionToken (args, state, output, { context }) {
        context.cookie.set({
            key: 'access_token',
            value: '',
            path: '/',
            expires: -1
        });

        context.cookie.set({
            key: 'refresh_token',
            value: '',
            path: '/',
            expires: -1
        });
    },

    /**
     * Устанавливаем временный токен для формы дополнительной регистрации
     * @param {Object} args
     * @param {Object} state
     * @param {Object} output
     * @param {Object} context
     */
    setRegisterExtraToken ({ auth }, state, output, { context }) {
        const accessToken = _.get(auth, 'access_token');
        const refreshToken = _.get(auth, 'refresh_token');
        const expires = new Date(Date.now() + (3600 * 24 * 1000));

        // Кука для токена на сутки
        context.cookie.set({
            key: 'registration_extra_access_token',
            value: accessToken,
            path: '/',
            expires
        });

        // Кука для рефреш-токена на 30 дней
        context.cookie.set({
            key: 'registration_extra_refresh_token',
            value: refreshToken,
            path: '/',
            expires: new Date(Date.now() + (3600 * 24 * 1000 * 30))
        });
    },

    unsetRegisterExtraToken (args, state, output, { context }) {
        context.cookie.set({
            key: 'registration_extra_access_token',
            value: '',
            path: '/',
            expires: -1
        });

        context.cookie.set({
            key: 'registration_extra_refresh_token',
            value: '',
            path: '/',
            expires: -1
        });
    },

    /**
     * Проверка на наличия access или refresh token'a
     * @param {Object} args
     * @param {Object} state
     * @param {Object} output
     * @param {Object} context
     */
    checkExistCookie (args, state, output, { context }) {
        const accessToken = context.cookie.get('access_token');

        if (accessToken) {
            output.exist();
            return;
        }

        output.notExist();
    },

    getArgFromCookie (argName, cookieKey) {
        return (args, state, output, { context }) => {
            args[argName] = context.cookie.get(cookieKey);
        };
    },

    unsetCookie ({ key }) {
        return (args, state, output, { context }) => {
            context.cookie.set({
                key: key,
                value: '',
                path: '/',
                expires: -1
            });
        };
    }
};



// WEBPACK FOOTER //
// ./actions/cookie.js